@if(isFirstParagraph && livestream.videoLayoutType === 'full_hero') {
<h-positioned-under-header>
    <ng-container *ngTemplateOutlet="mainSection"></ng-container>
</h-positioned-under-header>
} @else {
<ng-container *ngTemplateOutlet="mainSection"></ng-container>
}
<ng-template #mainSection>
    <section
        [class]="'block-' + livestream.videoLayoutType + '-livestream'"
        class="block-livestream"
        data-testid="block-livestream"
        data-nosnippet>
        @if (livestream.casterType === streamCasterType.FREECASTER) {
        <div
            class="freecaster-player"
            [attr.data-video-id]="livestream.videoId"
            [attr.data-autoplay]="livestream.videoAutoplay"
            [attr.data-muted]="livestream.videoMute"
            [attr.data-loop]="livestream.videoLoop"
            [attr.data-controls]="livestream.videoControls"
            [attr.data-dnt]="livestream.doNotTrack">
        </div>
        } @if (livestream.casterType === streamCasterType.LETSEE) {
        <div
            [class.new-player-full-hero]="livestream.videoLayoutType === 'full_hero'"
            [class.new-player]="livestream.videoLayoutType !== 'full_hero'">
            <iframe
                [src]="iframeUrl"
                title="Livestream video"
                i18n-title="@@hermes.livestream.title"
                allowfullscreen></iframe>
        </div>
        }
    </section>
</ng-template>
